<template>
    <div class="peribox">
        {{ delivery_lead_id }}
        <div class="perititle">
            <div>Delivery Agent Log Text</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>
        <div style="font-size: 12px; font-family: monospace; white-space: pre">{{ text }}</div>
    </div>
</template>

<script>
export default {
    props: [
        'app_id',
        'delivery_lead_id'
    ],
    data() {
        return {
            text: ''
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}/delivery-agent-log-text/${this.delivery_lead_id}`))
                .then((response) => {
                    this.text = response.data.text;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>